/**
 * Interceptor'dan yonlendirme koprusu.
 *
 * axios interceptor'i React agacinin disinda calisir; useNavigate oradan
 * cagrilamaz. Mevcut kod ayni problemi dispatch icin modul seviyesi bir
 * degiskenle cozuyor (bkz. setResponseInterceptor); ayni desen burada
 * yonlendirme icin tekrarlaniyor.
 */
let navigateToLoginImpl: (() => void) | undefined;

export function setLoginNavigator(fn: () => void): void {
  navigateToLoginImpl = fn;
}

export function navigateToLogin(): void {
  if (navigateToLoginImpl) {
    navigateToLoginImpl();
    return;
  }
  // React henuz mount olmadiysa: kok adrese don, App dogru ekrani secer.
  window.location.replace('/');
}
